export const IconSparkleFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="m9.97 5.577.603 1.672a6.63 6.63 0 0 0 3.987 3.987l1.672.603c.151.054.151.268 0 .322l-1.672.602a6.63 6.63 0 0 0-3.987 3.987l-.602 1.673a.171.171 0 0 1-.323 0l-.602-1.673a6.63 6.63 0 0 0-3.987-3.987l-1.673-.602a.172.172 0 0 1 0-.322l1.673-.603A6.63 6.63 0 0 0 9.046 7.25l.602-1.672a.171.171 0 0 1 .323 0M17.499 1.558l.305.846c.34.94 1.08 1.68 2.02 2.02l.846.305a.087.087 0 0 1 0 .163l-.847.305a3.36 3.36 0 0 0-2.019 2.02l-.305.846a.087.087 0 0 1-.163 0l-.306-.847a3.36 3.36 0 0 0-2.019-2.019l-.846-.305a.087.087 0 0 1 0-.163l.846-.306a3.36 3.36 0 0 0 2.02-2.019l.305-.846a.087.087 0 0 1 .163 0M17.499 15.937l.305.847c.34.94 1.08 1.68 2.02 2.02l.846.304a.087.087 0 0 1 0 .164l-.847.305a3.36 3.36 0 0 0-2.019 2.02l-.305.846a.087.087 0 0 1-.163 0l-.306-.847a3.36 3.36 0 0 0-2.019-2.019l-.846-.305a.087.087 0 0 1 0-.164l.846-.305a3.36 3.36 0 0 0 2.02-2.019l.305-.847c.027-.076.136-.076.163 0" />
    </svg>
  );
};
